import React from "react";

import {
  errorForm,
  fireNewRelicErrorEvent,
} from "@origin-digital/reporting-client";
import { Card, CardStackSection } from "@origin-digital/ods-core";
import { ErrorMessage } from "@origin-digital/messages";

import { AppContextConsumer } from "src/context/AppContext";

import content from "./content.json";

interface IState {
  error?: Error;
}

export class ErrorWrapper extends React.PureComponent<
  Record<string, unknown>,
  IState
> {
  public state: IState = {};

  private trackError = (error: Error) => {
    fireNewRelicErrorEvent(error);
    errorForm({
      errorCode: error.name,
      errorMessage: error.message,
    });
  };

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    const { children } = this.props;
    const { error } = this.state;

    return (
      <AppContextConsumer>
        {({ context }) => {
          const thrownError = error || context.error;
          if (thrownError) {
            this.trackError(thrownError);
            return (
              <CardStackSection data-id="templated-microsite-error">
                <Card>
                  <ErrorMessage heading={content.heading} text={content.text} />
                </Card>
              </CardStackSection>
            );
          }

          return children as unknown as React.ReactNode;
        }}
      </AppContextConsumer>
    );
  }
}
